import { Stack, LinearProgress } from "@mui/material"


const AimdLinearBar = ({ value , barHeight}) => {
    return (
        <Stack marginTop={{lg : 3 , md : 3, sm :2, xs : 1}} display="flex" justifyContent="center"  alignItems="center"  width="100%" >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    maxWidth: "600px",
                    width : "98%",
                    height: barHeight,
                    borderRadius: 4,
                    backgroundColor : "#EAF9F9 !important",
                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
                    //  boxShadow : '0px 211px 59px 0px rgba(0, 0, 0, 0.00), 0px 135px 54px 0px rgba(0, 0, 0, 0.01), 0px 76px 46px 0px rgba(0, 0, 0, 0.05), 0px 34px 34px 0px rgba(0, 0, 0, 0.09), 0px 8px 19px 0px rgba(0, 0, 0, 0.10)',
                    '& .MuiLinearProgress-barColorPrimary': {
                        background: "#72D8DA",
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
                    //     boxShadow: `
                    //     0px 8px 19px 0px #0000001A,
                    //     0px 34px 34px 0px #00000017,
                    //     0px 76px 46px 0px #0000000D,
                    //     0px 135px 54px 0px #00000003,
                    //     0px 211px 59px 0px #00000000
                    //   `,
                    }
                }}
            />
        </Stack>
    )
}

export default AimdLinearBar